import { render, staticRenderFns } from "./PopUpUpdatePrivacity.vue?vue&type=template&id=48499fa0&"
import script from "./PopUpUpdatePrivacity.vue?vue&type=script&lang=js&"
export * from "./PopUpUpdatePrivacity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48499fa0')) {
      api.createRecord('48499fa0', component.options)
    } else {
      api.reload('48499fa0', component.options)
    }
    module.hot.accept("./PopUpUpdatePrivacity.vue?vue&type=template&id=48499fa0&", function () {
      api.rerender('48499fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpUpdatePrivacity.vue"
export default component.exports